import { createLocalization } from '@clover-web-lib-sprout/common';

type LanguageKeys = {
  success: string;
  warning: string;
  error: string;
  info: string;
  closeButton: string;
  notification: string;
  upsell: string;
};

const localizations = createLocalization<LanguageKeys>();

localizations.addDefault({
  success: 'Success',
  warning: 'Warning',
  error: 'Error',
  info: 'Information',
  closeButton: 'Close',
  notification: 'You have notifications',
  upsell: 'Needs to figure out',
});

localizations.addLanguage('es', {
  success: 'Éxito',
  warning: 'Advertencia',
  error: 'Error',
  info: 'Información',
  closeButton: 'Cerrar',
  notification: 'Tienes notificacións',
  upsell: 'unsure ',
});

export const getLanguageStrings = localizations.getLanguage;
